<template>
  <div class="container-withdraw-account" :style="cssVars()">
    <div class="custom-nav-block" :style="`padding-top:${topBarHeight}px; background-color: #f7f6f9;`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="goPrevious">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.webp" alt="" />
          <span class="tit-left">{{ $t('lang.WithdrawalAccount.k033') }}</span>
        </template>
      </van-nav-bar>
    </div>

    <div class="main">
      <!-- 图标 -->
      <div class="account-tit">
        <div class="account-img">
          <img :src="icon | imgPath" alt="" />
        </div>
        <span class="line"></span>
        <div class="account-name">{{ withdrawalMethod }}</div>
      </div>

      <!-- 提现国家 -->
      <div class="select">
        <span>{{ $t('lang.BaseModule.k015') }}</span>
        <div class="country">
          <img :src="locaFlag | imgPath" alt="" />
          <div class="account-name">{{ locaCode }}</div>
        </div>
      </div>

      <div class="select">
        <span>{{ $t('lang.BaseModule.k041') }}</span>
        <input style="color: #333" type="text" :placeholder="$t('lang.WithdrawalAccount.k028')" v-model.trim="accountName" />
      </div>

      <div class="select">
        <span v-if="withdrawalMethod == 'PIX'">{{ $t('lang.WithdrawalAccount.k019') }}</span>
        <div class="select-account">
          <input
            v-if="withdrawalMethod == 'PIX'"
            type="text"
            placeholder="123.456.789-00"
            v-model="accountId"
            onkeyup="value=value.replace(/[^\d.-]/g,'')"
          />
        </div>
      </div>

      <div v-if="locaCode === 'BR'" class="select">
        <span>{{ $t('lang.WithdrawalAccount.k029') }}</span>
        <div class="phone-number-wrapper">
          <input
            type="tel"
            inputmode="numeric"
            maxlength="15"
            placeholder="(XX) 9XXXX-XXXX"
            :value="phoneNumberDisplay"
            @input="handlePhoneInput"
          />
        </div>
      </div>

      <!-- 保存按钮 -->
      <div class="save-btn" :class="{ 'save-btn-act': this.saveFlag() }" @click="handleSave">
        {{ $t('lang.BaseModule.k051') }}
      </div>
    </div>

    <!-- 弹窗 -->
    <van-dialog v-model="showDialog" :close-on-click-overlay="true" :showConfirmButton="false">
      <div class="pix-dialog">
        <div class="title">{{ $t('lang.WithdrawalAccount.k031') }}</div>
        <div class="tip">{{ $t('lang.WithdrawalAccount.k030') }}</div>
        <div class="account">123.456.789-00</div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { apiBindWithdrawAccount, apiEditWithdrawAccount } from '@/api/imee.js'

import _debounce from 'lodash/debounce'
import baseMixin from '../base.mixin.js'

// const BRAZIL_PHONE_REG = /^[1-9]{2}9\d{8}$/
// const BRAZIL_PHONE_INVALID_TOAST = 'Número de telefone inválido. Verifique o DDD e tente novamente.'

export default {
  mixins: [baseMixin],
  data() {
    return {
      phoneNumber: '',
      phoneNumberDisplay: '',
    }
  },
  methods: {
    formatBrazilPhoneInput(value) {
      const digits = String(value || '')
        .replace(/\D/g, '')
        .slice(0, 11)
      if (!digits.length) return ''
      if (digits.length === 1) return `(${digits}`
      if (digits.length === 2) return `(${digits})`
      if (digits.length <= 7) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`
      return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`
    },
    handlePhoneInput(event) {
      const digits = event.target.value.replace(/\D/g, '').slice(0, 11)
      this.phoneNumber = digits
      this.phoneNumberDisplay = this.formatBrazilPhoneInput(digits)
    },
    // validateBrazilPhone() {
    //   return BRAZIL_PHONE_REG.test(this.phoneNumber)
    // },
    // 保存
    handleSave: _debounce(
      function () {
        // 去掉空格
        const strAccountId = `${this.accountId}`
        this.accountId = strAccountId.replace(/\s*/g, '')

        // 判断emoji表情
        if (this.hasEmojiCharacter(this.accountName)) {
          this.accountName = ''
          this.$client.showToast(this.$t('lang.WithdrawalAccount.k024'))
          return
        }

        // pix校验
        if (this.withdrawalMethod === 'PIX') {
          const tempRules1 = this.accountId.length === 11
          const tempRules2 =
            this.accountId.length === 14 && this.accountId.charAt(3) === '.' && this.accountId.charAt(7) === '.' && this.accountId.charAt(11) === '-'
          const tempFlag = tempRules1 || tempRules2
          if (!tempFlag) {
            this.showDialog = true
            return
          }

          // 手机号格式由服务端校验
          // if (this.locaCode === 'BR') {
          //   if (!this.validateBrazilPhone()) {
          //     this.$client.showToast(BRAZIL_PHONE_INVALID_TOAST)
          //     return
          //   }
          // }
        }

        const data = {
          accountId: this.accountId,
          accountName: this.accountName,
        }

        if (this.locaCode === 'BR') {
          data.phoneNumber = this.phoneNumber
        }

        // edit
        if (this.cfgId) {
          apiEditWithdrawAccount(data, this.cfgId).then((res) => {
            if (res.status === 200) {
              this.$client.showToast(res.message)
              const timer = setTimeout(() => {
                clearTimeout(timer)
                this.jumpWithdrawal()
              }, 500)
            }
          })
        }
        // add
        else {
          data.withdrawalMethod = this.withdrawalMethod
          apiBindWithdrawAccount(data).then((res) => {
            if (res.status === 200) {
              this.$client.showToast(res.message)
              const timer = setTimeout(() => {
                clearTimeout(timer)
                this.jumpWithdrawal()
              }, 500)
            }
          })
        }
      },
      3000,
      {
        leading: true,
        trailing: false,
      }
    ),
    // 保存校验
    saveFlag() {
      if (!this.accountId || !this.accountName) {
        return false
      }
      if (this.locaCode === 'BR' && this.phoneNumber.length !== 11) {
        return false
      }
      return true
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../base.scss';
</style>
